<template>
  <div>
    <v-app-bar app absolute dense dark :color="mainColor">
      <v-toolbar-title class="d-flex flex-row">
        <v-avatar
          height="32px"
          width="32px"
          min-width="32px"
          @click.stop="drawer = !drawer"
        >
          <img src="../assets/header-logo.png" />
        </v-avatar>
        <h1 class="title ml-1">{{ siteName }}</h1>
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="doLoad">
        <v-progress-circular
          v-show="loading"
          color="white"
          :indeterminate="loading"
        ></v-progress-circular>
        <v-icon v-show="!loading" class="white--text">mdi-reload</v-icon>
      </v-btn>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      :right="right"
      disable-resize-watcher
    >
      <v-list dense>
        <v-list-item>
          <span class="ml-2 caption"
            >Sigin in by {{ provider.groupLineOfficialAccountName }}</span
          >
        </v-list-item>
        <v-list-item>
          <v-avatar
            height="32px"
            width="32px"
            min-width="32px"
            @click.stop="drawer = !drawer"
          >
            <img
              v-if="user.picture !== ''"
              :src="user.picture"
              :alt="user.name"
            />
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-avatar>
          <span class="ml-2">{{ user.name }}</span>
        </v-list-item>
        <v-list-item title :to="signout.to">
          <v-list-item-action>
            <v-icon>{{ signout.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ signout.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getDevices } from '@/api'
import { SITE_NAME, MAIN_COLOR } from '@/constants'

const loadDevicesIntervalTime = 30000 // 30秒

export default {
  name: 'AppHeader',
  data() {
    return {
      siteName: SITE_NAME,
      mainColor: MAIN_COLOR,
      drawer: false,
      right: true,
      loading: false,
      serachLoading: false,
      signout: {
        title: 'サインアウト',
        to: '/auth/sign-out',
        icon: 'mdi-logout-variant'
      },
      intervalId: null
    }
  },
  computed: {
    ...mapGetters(['user', 'provider'])
  },
  mounted() {
    console.log('load devices polling start.')
    this.intervalId = setInterval(() => {
      this.doLoad()
    }, loadDevicesIntervalTime)
  },
  beforeDestroy() {
    console.log('load devices polling stop.')
    clearInterval(this.intervalId)
  },
  methods: {
    ...mapActions([
      'addDevice',
      'setInfoDeviceId',
      'unsetInfoDeviceId',
      'setDevices',
      'doReloadMap'
    ]),
    async doLoad() {
      if (this.loading) {
        return
      }
      this.loading = true
      await this.initDevices()
      this.doReloadMap()
      this.loading = false
    },
    async initDevices() {
      console.log('load devices...')
      let res
      try {
        res = await getDevices(this.$route.params.provider)
      } catch (e) {
        console.error(e)
        alert('サーバエラーが発生しました。ログイン画面に遷移します。')
        this.$router.push('/auth/sign-out')
        return
      }
      this.setDevices(res.devices)
    }
  }
}
</script>
